import { render, staticRenderFns } from "./VideoCoverItem.vue?vue&type=template&id=004ff4ce&scoped=true&"
import script from "./VideoCoverItem.vue?vue&type=script&lang=js&"
export * from "./VideoCoverItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoCoverItem.vue?vue&type=style&index=0&id=004ff4ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ff4ce",
  null
  
)

export default component.exports